<template>
	<p class="text-gray-400 text-sm"><slot></slot></p>
</template>
